import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, TermFilter } from "../../../../../../_helpers/Helpers";
import * as actions from "../../../_redux/personnels/PersonnelsAction";
import { usePersonnelsUIContext } from "../PersonnelsUIContext";

const prepareFilter = (queryParams, values) => {
  let { term, tcKimlikNo, name, surname, personnelTypeId } = values;
  const newQueryParams = { ...queryParams };
  const filter = { tcKimlikNo, name, surname, personnelTypeId };
  newQueryParams.filter = filter;
  newQueryParams.term = term;
  return newQueryParams;
};

export function PersonnelsFilter() {
  // Personnels UI Context
  const personnelsUIContext = usePersonnelsUIContext();
  const personnelsUIProps = useMemo(() => {
    return {
      setQueryParams: personnelsUIContext.setQueryParams,
      queryParams: personnelsUIContext.queryParams,
    };
  }, [personnelsUIContext]);
  
  const dispatch = useDispatch();
  const { currentActiveTerm, personnelTypes } = useSelector(
    (state) => ({
      currentActiveTerm: state.auth.user.currentActiveTerm,
      personnelTypes: state.personnels.personnelTypes
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.getPersonnelTypes());
  }, [dispatch]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(personnelsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, personnelsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      personnelsUIProps.setQueryParams(newQueryParams);
    }
  };

  const personnelTypesOptions = FilterOptions.concat(personnelTypes);

  return (
    <Formik
      initialValues={{
        term: currentActiveTerm,
        tcKimlikNo: "",
        name: "",
        surname: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <TermFilter
            handleSubmit={handleSubmit}
            handleBlur={handleBlur}
            handleChange={handleChange}
            values={values}
          />
          <div className="form-group row">            
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="tcKimlikNo"
                placeholder="TC Kimlik No"
                onBlur={handleBlur}
                value={values.tcKimlikNo}
                onChange={(e) => {
                  setFieldValue("tcKimlikNo", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>TC Kimlik No</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect
                options={personnelTypesOptions}
                value={values.personnelTypeId}
                placeholder="Personel Türü"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("personnelTypeId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Personel Türü</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}